/**
 * Widget « Vidéos de votre commune » : un site communal colle une iframe qui
 * affiche les derniers reportages citant sa commune. Chaque intégration crée
 * un lien de crédit (backlink) vers la fiche commune et le trafic est mesuré
 * comme trafic iframe dans /audience (routes /api/public/embed/*).
 */

export const WIDGET_SITE = "https://corsetv.com";

export type WidgetSize = { slug: string; label: string; count: number; height: number };

export const widgetSizes: WidgetSize[] = [
  { slug: "s", label: "Compact — 3 reportages", count: 3, height: 320 },
  { slug: "m", label: "Standard — 6 reportages", count: 6, height: 520 },
  { slug: "l", label: "Large — 9 reportages", count: 9, height: 720 },
];

export function communeWidgetSrc(
  origin: string,
  slug: string,
  { count = 6, source = "mairie" }: { count?: number; source?: string } = {},
) {
  return `${origin}/api/public/embed/commune/${slug}?n=${count}&utm_source=${encodeURIComponent(source)}`;
}

export function communePageUrl(origin: string, slug: string) {
  return `${origin}/commune/${slug}`;
}

const esc = (s: string) =>
  s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

/** Code prêt à coller sur un site communal (iframe + légende avec backlink). */
export function communeWidgetSnippet(
  origin: string,
  commune: { slug: string; name: string },
  { count = 6, source = "mairie" }: { count?: number; source?: string } = {},
) {
  const size = widgetSizes.find((s) => s.count === count) ?? widgetSizes[1]!;
  const src = communeWidgetSrc(origin, commune.slug, { count, source });
  const page = communePageUrl(origin, commune.slug);
  return `<figure class="corsetv-commune" style="margin:1.5rem 0">
  <iframe src="${src}" title="Vidéos de ${esc(commune.name)} — Corse TV" loading="lazy" style="border:0;width:100%;height:${size.height}px;display:block"></iframe>
  <figcaption style="font:14px/1.4 system-ui,sans-serif;margin-top:.5rem;color:#555">
    <a href="${page}">Reportages sur ${esc(commune.name)}</a> — sélection proposée par <a href="${origin}/">Corse TV</a>, la vidéothèque des reportages sur la Corse.
  </figcaption>
</figure>`;
}
